import React from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import "photoswipe/dist/photoswipe.css";
import "photoswipe/dist/default-skin/default-skin.css";
// import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";
import "../Gallery.css";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
const CbseKhoKho = () => {
  const numbers = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
  ];
  // const i;
  const images = [
    {
      original: "http://www.mpsckp.com/gallery/cbse_kho_kho/1.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/cbse_kho_kho/1.jpg",
    },
    {
      original: "http://www.mpsckp.com/gallery/cbse_kho_kho/2.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/cbse_kho_kho/2.jpg",
    },
    {
      original: "http://www.mpsckp.com/gallery/cbse_kho_kho/3.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/cbse_kho_kho/3.jpg",
    },
    {
      original: "http://www.mpsckp.com/gallery/cbse_kho_kho/4.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/cbse_kho_kho/4.jpg",
    },
    {
      original: "http://www.mpsckp.com/gallery/cbse_kho_kho/5.jpg",
      thumbnail: "http://www.mpsckp.com/gallery/cbse_kho_kho/5.jpg",
    },
  ];

  // const listItems = numbers.map((number, index) => {

  //     return (

  //       [{

  //       }

  //     ]
  //     );

  // });
  // console.log(listItems);

  return (
    <div className="inner-body">
      <Container fluid>
        <Row className="inner">
          <div className="inner-head-outer">
            <div className="inner-head">
              <Col>
                <h2>CBSE Kho Kho Tournament East Zone 2024</h2>
                <Breadcrumb>
                  <Breadcrumb.Item href="../">
                    <i className="fa fa-home"></i> Home
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    <Link to={"/mgallery"}>
                      <i className="fa fa-camera"></i> Gallery
                    </Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>
                    CBSE Kho Kho Tournament East Zone 2024
                  </Breadcrumb.Item>
                </Breadcrumb>
              </Col>
              <Col>
                <blockquote>
                  <h5>UNDER -14 GIRLS CATEGORY:</h5>
                  <h6>RUNNER UP</h6>

                  <h5>UNDER -19 GIRLS CATEGORY:</h5>
                  <h6>SECOND RUNNER UP</h6>

                  <h5>UNDER -19 BOYS CATEGORY:</h5>
                  <h6>SECOND RUNNER UP</h6>
                </blockquote>
              </Col>
            </div>
          </div>
        </Row>
      </Container>
      <div className="mib relative">
        <div className="leftline"></div>

        <div className="bottomline"></div>
        <Container>
          {/* <Gallery>{listItems}</Gallery> */}
          <Row>
            <Col>
              <ImageGallery items={images} lazyLoad={true} />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default CbseKhoKho;
